export default {"src":"/_next/static/media/section_communaute_2.43692e02.svg","height":435,"width":1031};